import React from 'react';
import { useObserver } from 'mobx-react-lite';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { FaEdit } from 'react-icons/fa';
import { ComponentField } from '../../../infrastructure/dynamic-forms/ComponentField';
import { AddressRow } from './module-form/AddressRow';
import { AddressModal } from '../validator/AddressModal';
import { MarketChangeModal } from '../../locale-management/warning-modal/MarketChangeModal';
import { AddressDisplay } from '../AddressDisplay';
import { useModuleStore } from '../../enrollment-process/module-management/model/ModuleStoreHook';
import { useRootStore } from '../../root/RootStoreHooks';
import { useModuleDisplayMode } from '../../enrollment-process/steps-management/components/step-layouts/accordion/ModuleDisplayMode';
import { AddressEntryType, YlAddress } from '../../../infrastructure/forms/YlAddress';

export const AddressEntry = () => {
  const { t } = useTranslation();
  const rootStore = useRootStore();
  const addressEntry = useModuleStore('addressEntry');
  const displayMode = useModuleDisplayMode();
  function getCustomerAttributes(field: ComponentField) {
    const attr = {} as any;
    if (field.maxLength) {
      attr.maxLength = field.maxLength;
    }

    if (field.minLength) {
      attr.minLength = field.minLength;
    }

    return attr;
  }

  return useObserver(() => {
    const form = addressEntry.reactForm;
    const { countryIso } = rootStore.enrollmentStatus;
    if (displayMode) {
      return <AddressDisplay address={addressEntry.data} hideStreet3 oneLiner />;
    }

    return (
      <Form>
        {addressEntry.shouldConfirmAddress && (
          <>
            {/* eslint-disable-next-line */}
            <label htmlFor="sameAsPrimary" onClick={() => addressEntry.setInEditMode()}>
              <span className="text-primary">
                {' '}
                <FaEdit id="sameAsPrimary" data-testid="edit-address" />
              </span>{' '}
              {t('MainAddressSameAsShipping')}
            </label>
            {!addressEntry.inEditMode && <AddressDisplay address={addressEntry.data!} hideStreet3 hideTitle />}
          </>
        )}

        {addressEntry.inEditMode &&
          addressEntry.form.rows.map((row: AddressRow, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <YlAddress row={row}
                        index={index}
                        form={addressEntry.reactForm}
                        entryComponent={addressEntry}
                        entryType={AddressEntryType.MainAddress}
                        countryIso={addressEntry.reactForm.$.country.value}
                        />
          ))}
        <MarketChangeModal
          showWarning={addressEntry.showMarketChangeWarning}
          hide={addressEntry.cancelMarketChange}
          agreeAndContinue={rootStore.cancelEnrollment}
          country={addressEntry.targetCountry}
          language={undefined}
        />
        <AddressModal store={addressEntry.addressValidator} />
      </Form>
    );
  });
};
